'use client';

import { useMutation } from '@tanstack/react-query';

import { appStateService } from '@/state/app.state.service';

import { postPublisherEvent } from './publisherEventsTransport';

const isWebhookEnabled = (eventName: string): boolean => {
  const integrations = appStateService.initialBoot.get()?.integrations;

  return !!(
    integrations?.eventsV2WebhookUrl || integrations?.enabledWebhookEventsV2?.includes(eventName)
  );
};

export const useTrackPublisherEvents = () => {
  const trackPublisherPreLoginEvent = useMutation({
    mutationKey: ['trackPublisherPreLoginEvent'],
    mutationFn: async (eventData: any) => {
      if (!isWebhookEnabled(eventData.eventName)) {
        return;
      }

      return await postPublisherEvent(`/game-portal/events/v2/pre-login`, eventData);
    },
    onError: (error: any) => {
      console.error('Error tracking publisher pre-login event', error);
    }
  });

  const trackPublisherPostLoginEvent = useMutation({
    mutationKey: ['trackPublisherPostLoginEvent'],
    mutationFn: async (eventData: any) => {
      if (!isWebhookEnabled(eventData.eventName)) {
        return;
      }

      return await postPublisherEvent(`/game-portal/events/v2/post-login`, eventData);
    },
    onError: (error: any) => {
      console.error('Error tracking publisher post-login event', error);
    }
  });

  const trackPublisherUIEvent = useMutation({
    mutationKey: ['trackPublisherUIEvent'],
    mutationFn: async (eventData: any) => {
      if (!isWebhookEnabled(eventData.eventName)) {
        return;
      }

      return await postPublisherEvent(`/game-portal/events/v2/ui-event`, eventData);
    },
    onError: (error: any) => {
      console.error('Error tracking publisher UI event', error);
    }
  });

  const trackPublisherWebStoreEvent = useMutation({
    mutationKey: ['trackPublisherWebstoreEvent'],
    mutationFn: async (event: { eventType: string; data: any }) => {
      if (!isWebhookEnabled(event.data.eventName)) {
        return;
      }

      return await postPublisherEvent(`/store/events/v2/${event.eventType}`, event.data);
    },
    onError: (error: any) => {
      console.error('Error tracking publisher webstore event', error);
    }
  });

  return {
    trackPublisherPreLoginEvent,
    trackPublisherPostLoginEvent,
    trackPublisherUIEvent,
    trackPublisherWebStoreEvent
  };
};
